
import React from 'react';

interface ImagePreviewProps {
  imageSrc: string;
  onClearImage: () => void;
}

const XCircleIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={`w-5 h-5 ${className}`}>
        <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
    </svg>
);


const ImagePreview: React.FC<ImagePreviewProps> = ({ imageSrc, onClearImage }) => {
  return (
    <div className="relative group w-full aspect-video rounded-lg overflow-hidden shadow-lg border-2 border-slate-600">
      <img src={imageSrc} alt="Immagine Catturata" className="w-full h-full object-contain bg-slate-700" />
      <button
        onClick={onClearImage}
        title="Rimuovi immagine"
        className="absolute top-2 right-2 p-1.5 bg-red-600/80 text-white rounded-full opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity duration-200 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-slate-700"
      >
        <XCircleIcon />
        <span className="sr-only">Rimuovi immagine</span>
      </button>
    </div>
  );
};

export default ImagePreview;
